// extracted by mini-css-extract-plugin
export default {"section":"GSKC3BOV","title":"_3kPJpdoG","grid":"sXs-ICUw","cell":"TQqUvPW_","loading":"_3Ab2k4Zv"};